/**
 * Debug logger utility.
 * Use `console.warn` / `console.error` directly for real warnings and errors.
 */
export const debugLog = (...args: unknown[]): void => {
  void args;
};
